import React, {Component} from 'react';


import CheckboxField from "../../lib/mdb/checkbox-field";

class DoNotSaveField extends Component {
    render() {

        const {messages} = this.props;

        return (
            <React.Fragment>
                <div className="form-group m-0">
                    <CheckboxField
                        key="paymentMethod-cpDoNotSavePmEnabled"
                        name="cpDoNotSavePmEnabled"
                        description={messages["payment.cpDoNotSavePmEnabled.description.label"]}
                        className="form-check pl-0"
                        inputClass="form-check-input"
                        labelClass="form-check-label"
                        aria-required="true"
                    />
                </div>

            </React.Fragment>
        )
    }
}

export default DoNotSaveField
